import { Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomeTableBtn from "../../../../components/custome-table-button/CustomeTableBtn";
import DashboardPagesLayout from "../../customerServiceDashboard/components/DashboardPagesLayout";
import SelectSearchFilter from "../../../../components/CustomeFilter/SelectSearchFilter";
import SearchFilter from "../../../../components/CustomeFilter/SearchFilter";
import { setButtonBackgroundColor, getPriceValidity } from "./utils";
import { apiURL, isDev } from "../../../../config/default";
import axios from "axios";
import TableLoader from "../../../../components/TableSkelton/TableLoader";
import PriceCard from "../../../../components/price-card/price-card";
import PriceCardDrawer from "../../../../components/price-card/price-card-components/price-card-drawer";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { getAllStores } from "../../../../actions/store";
import { subCategoryNames } from "../../../../actions/subCategory";
import { createSearchParams } from "react-router-dom";
import PricingSidebar from "./components/pricing-side";
import { PricingTabs } from "./components/SharedComponents";
import PriceVariables from "./components/PriceVariables";
import PriorityVariables from "./components/PriorityVariables";
import FrequencyVariables from "./components/FrequencyVariables";
import BatchUpdateDrawerContent from "./components/BatchUpdateDrawerContent";
import ExportBrandDrawerContent from "./components/ExportBrandDrawerContent";
import ManageIgnoredCompetitors from "./components/ManageIgnoredCompetitors";
import GlobalPricingSettings from "./components/GlobalPricingSettings";
import { useGetSundialPriceHistoryQuery, useLazyGetSundialPriceHistoryQuery, useGetPriceHistoryBrandsQuery } from "../../../../reducers/priceHistoryApi";
import { useGetSettingByKeyQuery } from "../../../../reducers/settingsApi";
import * as XLSX from "xlsx";

const DynamicPricing = () => {
  // Helper function to format date as MM/DD/YYYY
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };
  const getTodayInLA = () => {
    const laDate = new Date(
      new Date().toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );

    // Normalize to start of day
    laDate.setHours(0, 0, 0, 0);
    return laDate;
  };

  const isSaleActiveToday = (startDate, endDate) => {
    if (!startDate || !endDate) return false;

    const todayLA = getTodayInLA();

    const start = new Date(startDate);
    const end = new Date(endDate);

    // Normalize start and end
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return todayLA >= start && todayLA <= end;
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("modelNumber");
  const brandId = queryParams.get("brand");

  const [activeTab, setActiveTab] = useState("dashboard");
  const [activePrioritySubTab, setActivePrioritySubTab] = useState("brand");

  const [selectedItemBrandId, setSelectedItemBrandId] = useState("");
  const [productInfo, setProductInfo] = useState({});
  const [crawlers, setCrawlwers] = useState([]);
  const [pagePagination, setPagination] = useState({
    currentPage: 1,
  });

  const [Brand, setBrand] = useState([]);
  const [Categories, setCategories] = useState([]);
  const [dynamicPricing, setDynamicPricing] = useState({
    open: false,
    edit: "",
    title: "",
  });

  const [Edit, setEdit] = useState({
    open: false,
    edit: "",
    title: "",
  });

  const [updateLatestDrawer, setUpdateLatestDrawer] = useState({
    open: false,
    edit: "",
    title: "",
  });
  const [SearchFillter, setSearchFillter] = useState({
    title: name ?? "",
    brandId: brandId ?? "",
    categoryName: "",
    discountId: "",
    errorCode: "",
    crawlStage: "",
    errorMarked: "",
    crawlType: "",
  });
  const [exportDrawer, setExportDrawer] = useState({ open: false, title: "Export Price History" });
  const [ignoreCompetitorDrawer, setIgnoreCompetitorDrawer] = useState({ open: false, title: "Manage Ignored Competitors" });
  const [globalPricingSettingsDrawer, setGlobalPricingSettingsDrawer] = useState({ open: false, title: "Global Pricing Settings" });

  const [isExporting, setIsExporting] = useState(false);
  const [triggerExportFetch] = useLazyGetSundialPriceHistoryQuery();

  const handleRefund = (itemId) => {
    setEdit({
      open: true,
      edit: "pricing",
      title: "Pricing",
    });
    const filterArray = crawlers.filter((value) => value.productId === itemId);
    setProductInfo(...filterArray);
  };

  const handleDetailClick = (item) => {
    setDynamicPricing({
      open: true,
      edit: "pricing",
      title: "Pricing",
    });
    setSelectedItemBrandId(item);
    setProductInfo(item);
  };

  const handleChange = (e, value) => {
    const options = {
      pathname: "/admin/dynamic-pricing",
      search: `?${createSearchParams({
        page: value,
      })}`,
    };
    navigate(options, { replace: true });
    setPagination({ ...pagePagination, currentPage: value });
  };

  const resetToFirstPage = () => {
    setPagination((prev) => ({ ...prev, currentPage: 1 }));
    navigate(
      {
        pathname: "/admin/dynamic-pricing",
        search: `?${createSearchParams({ page: 1 })}`,
      },
      { replace: true }
    );
  };

  const handleExportAll = async (selectedBrands) => {
    try {
      setIsExporting(true);
      // Fetch all products with current filters by setting limit to the total count
      // brandId is provided as a comma separated string from the drawer if specified
      const result = await triggerExportFetch({
        search: SearchFillter.title,
        brandId: selectedBrands || SearchFillter.brandId,
        categoryName: SearchFillter.categoryName,
        page: 1,
        limit: pagePagination.count || 10000, // Fallback to a large number if count is missing
        bulk: true
      }).unwrap();

      if (result?.success && result?.data?.data) {
        const exportData = result.data.data.map((item) => {
          const keyPrice = Number(item?.keyPrice) || 0;
          const evenPrice = Number(item?.evenPrice) || 0;
          
          const marginStr = (keyPrice && evenPrice)
            ? `${(((keyPrice - evenPrice) / keyPrice) * 100).toFixed(2)}%`
            : "N/A";
          
          const marginDollar = (keyPrice && evenPrice)
            ? `$${(keyPrice - evenPrice).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : "N/A";

          const saleStatus = isSaleActiveToday(item?.saleStartDate, item?.saleEndDate)
            ? `${formatDate(item.saleStartDate)} - ${formatDate(item.saleEndDate)}`
            : "No";

          const salePriceValidity = (item?.scrapedAt && item?.saleStartDate && item?.saleEndDate &&
                    new Date(item.scrapedAt) >= new Date(item.saleStartDate) &&
                    new Date(item.scrapedAt) <= new Date(item.saleEndDate)) ? "Yes" : "No";

          const { isValid: saleCrawlStatus, days: saleCrawlDays } = getPriceValidity(item?.scrapedAt, item?.saleCrawlFrequency);
          const { isValid: crawlStatus, days: crawlDays } = getPriceValidity(item?.scrapedAt, item?.crawlFrequency);
          const { isValid: priceValidityStatus, days: priceValidityDays } = getPriceValidity(item?.scrapedAt, outdatedDays);

          const status = item?.linkStatus;
          let displayStatus = status || "-";
          if (status === "valid") displayStatus = "Valid";
          else if (status === "invalid") displayStatus = "Invalid";
          else if (status === "notFound") displayStatus = "Not Found";

          return {
            "Brand": item.manufacturer || "Sunpan",
            "Category": item.categoryName || "N/A",
            "Item Name": item.productName,
            "SKU": item.sku,
            "Inventory": item.quantity,
            "Priority": item.priorityPoint,
            "On Sale": saleStatus,
            "Sale Dynamic Price Validity": salePriceValidity,
            "Last Crawl Date": formatDate(item.scrapedAt),
            "Sale Crawl Frequency": (item?.saleStartDate && item?.saleEndDate && item?.scrapedAt &&
              new Date(item.scrapedAt) >= new Date(item.saleStartDate) &&
              new Date(item.scrapedAt) <= new Date(item.saleEndDate)) 
              ? `${saleCrawlStatus === "Yes" ? "OK" : "Pending"} (${saleCrawlDays})` 
              : "-",
            "Crawl Frequency": `${crawlStatus === "Yes" ? "OK" : "Pending"} (${crawlDays})`,
            "Price Ranking": `${item.priceRanking || 0}/${item.totalSallers || 0}`,
            "Key Price": `$${keyPrice.toLocaleString(undefined, { minimumFractionDigits: 2 })}`,
            "Margin $": marginDollar,
            "Margin %": marginStr,
            "Key Price Validity": `${priceValidityStatus} (${priceValidityDays})`,
            "Link Status": displayStatus,
          };
        });

        const ws = XLSX.utils.json_to_sheet(exportData);
        // Set column widths for better readability in Excel
        const wscols = [
          { wch: 15 }, // Brand
          { wch: 20 }, // Category
          { wch: 40 }, // Item Name
          { wch: 25 }, // SKU
          { wch: 10 }, // Inventory
          { wch: 10 }, // Priority
          { wch: 25 }, // On Sale
          { wch: 25 }, // Sale Dynamic Price Validity
          { wch: 15 }, // Last Crawl Date
          { wch: 25 }, // Sale Crawl Frequency
          { wch: 25 }, // Crawl Frequency
          { wch: 15 }, // Price Ranking
          { wch: 15 }, // Key Price
          { wch: 15 }, // Margin $
          { wch: 15 }, // Margin %
          { wch: 25 }, // Key Price Validity
          { wch: 15 }, // Link Status
        ];
        ws['!cols'] = wscols;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Dynamic Pricing History");
        XLSX.writeFile(wb, `Dynamic_Pricing_Report_${new Date().toISOString().split('T')[0]}.xlsx`);
      }
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setIsExporting(false);
    }
  };


  const { data: brandsResponse } = useGetPriceHistoryBrandsQuery();

  useEffect(() => {
    if (brandsResponse?.success && Array.isArray(brandsResponse.data)) {
      const brands = brandsResponse.data.map((item) => ({
        id: item?._id || item?.id,
        value: item?.fullName || item?.name,
        label: item?.fullName || item?.name,
      }));
      setBrand(brands);
    }
  }, [brandsResponse]);

  const fetchCategoryData = async () => {
    try {
      const res = await dispatch(subCategoryNames());
      // Handle both wrapped response { success, data } and direct array response
      const categoryData = res?.success ? res?.data : (Array.isArray(res) ? res : []);

      if (categoryData && categoryData.length > 0) {
        const categories = categoryData.map((item) => ({
          id: item?._id,
          value: item?.name,
          label: item?.name,
        }));
        setCategories(categories);
      }
    } catch (error) {
      console.log("error fetching categories: ", error);
    }
  };

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const { data: settingsResponse } = useGetSettingByKeyQuery('app.pricinghistory');

  const outdatedDays = React.useMemo(() => {
    let value = settingsResponse?.data?.value;
    if (typeof value === 'string') {
      try { value = JSON.parse(value); } catch (e) { return 7; }
    }
    return value?.veriables?.outdated ? Number(value.veriables.outdated) : 7;
  }, [settingsResponse]);

  const { data: apiResponse, isLoading: isHistoryLoading } = useGetSundialPriceHistoryQuery({
    search: SearchFillter.title,
    brandId: SearchFillter.brandId,
    categoryName: SearchFillter.categoryName,
    page: pagePagination.currentPage,
  }, {
    skip: activeTab !== "dashboard"
  });
  // console.log("apiResponse", apiResponse?.data?.data);

  useEffect(() => {
    if (apiResponse?.success) {
      // Transform flat data to nested structure for compatibility with components like PriceCard
      const transformedData = apiResponse?.data?.data?.map(item => ({
        ...item,
        productId: {
          _id: item.productId,
          mainImage: item.mainImage,
          productName: item.productName,
          sku: item.sku,
          quantity: item.quantity,
          price: item.keyPrice,
          manufacturer: item.manufacturer,
          categoryName: item.categoryName,
          modelNumber: item.sku, // Fallback model number to SKU
        },
        // Populate crawlReport for backward compatibility with PriceCard/PricingSidebar
        crawlReport: {
          crawlerDateTime: item.scrapedAt,
          productMatchingStatus: "Price Match", // Default status
          linkFound: true,
          sundialExists: true,
        },
        _id: item.productId,
        name: item.productName,
      }));
      setCrawlwers(transformedData);
      setPagination(apiResponse.data.pagination);
    }
  }, [apiResponse]);

  const renderDashboardTable = () => (
    <div className="dashboard-pages-table overflow-auto">
      <table className="table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Brand</th>
            <th>Category</th>
            <th>Item name</th>
            <th>SKU</th>
            <th>Inventory</th>
            <th>Priority</th>
            <th>On Sale</th>
            <th> Sale Dynamic Price Validity </th>
            <th>Last Crawl Date</th>
            <th>Sale Crawl Frequency</th>
            <th>Crawl Frequency</th>
            <th>Price Ranking</th>
            <th>Key Price</th>
            <th>Margin $</th>
            <th>Margin %</th>
            <th>Key Price Validity</th>
            <th>Link Status</th>
            <th>Analyze</th>
          </tr>
        </thead>
        <tbody>
          {crawlers?.length ? (
            crawlers.map((item) => (
              <tr key={item.productId}>
                <td>
                  <img
                    src={item?.mainImage}
                    alt={item?.productName}
                    style={{ width: "40px", height: "40px", objectFit: "contain" }}
                  />
                </td>
                <td>{item?.manufacturer || "Sunpan"}</td>
                <td>{item?.categoryName || "N/A"}</td>
                <td>
                  <a
                    href={
                       isDev
                        ? `https://qasundial.sundialhome.com/product/${item?.slug}`
                        : `https://www.sundialhome.com/product/${item?.slug}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span
                      className="text-primary cursor-pointer font-weight-bold"
                      style={{
                        color: '#007bff',
                        fontSize: '12px',
                        maxWidth: '150px',
                        display: 'inline-block',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        cursor: "pointer"
                      }}

                    >
                      {item?.productName}
                    </span>
                  </a>
                </td>
                {/* {console.log("item",item)} */}
                <td>
                  <span
                    className="text-primary cursor-pointer font-weight-bold"
                    style={{ color: '#007bff', fontSize: '12px', cursor: 'pointer' }}
                    onClick={() =>
                      navigate(`/admin/products?sku=${item?.sku || item?.productId?.sku || ""}`)
                    }
                  >
                    {item?.sku}
                  </span>
                </td>
                <td>{item?.quantity}</td>
                <td>{item?.priorityPoint}</td>
                <td>
                  {isSaleActiveToday(item?.saleStartDate, item?.saleEndDate)
                    ? `${formatDate(item.saleStartDate)} - ${formatDate(item.saleEndDate)}`
                    : ''}
                </td>

                <td>
                  {item?.scrapedAt && item?.saleStartDate && item?.saleEndDate &&
                    new Date(item.scrapedAt) >= new Date(item.saleStartDate) &&
                    new Date(item.scrapedAt) <= new Date(item.saleEndDate)
                    ? "Yes" : "No"}
                </td>
                <td>{formatDate(item?.scrapedAt)}</td>
                <td>
                  {(() => {
                    if (!item?.saleStartDate || !item?.saleEndDate || !item?.scrapedAt) return <div className="text-center">-</div>;

                    const scrapedDate = new Date(item.scrapedAt);
                    const saleStart = new Date(item.saleStartDate);
                    const saleEnd = new Date(item.saleEndDate);

                    if (scrapedDate < saleStart || scrapedDate > saleEnd) {
                      return <div className="text-center">-</div>;
                    }

                    const { isValid, days } = getPriceValidity(item?.scrapedAt, item?.saleCrawlFrequency);
                    const label = isValid === "Yes" ? "OK" : "Pending";
                    return (
                      <div className="d-flex flex-column align-items-center">
                        <span className={` font-weight-bold`}>{label}</span>
                        <span className="text-muted small">{days}</span>
                      </div>
                    );
                  })()}
                </td>
                <td>
                  {(() => {
                    const { isValid, days } = getPriceValidity(item?.scrapedAt, item?.crawlFrequency);
                    const label = isValid === "Yes" ? "OK" : "Pending";
                    return (
                      <div className="d-flex flex-column align-items-center">
                        <span className={` font-weight-bold`}>{label}</span>
                        <span className="text-muted small">{days}</span>
                      </div>
                    );
                  })()}
                </td>
                <td>{item?.priceRanking}/{item?.totalSallers}</td>
                <td>${item?.keyPrice?.toLocaleString()}</td>
                <td>
                  {item?.keyPrice && item?.evenPrice
                    ? `$${(item.keyPrice - item.evenPrice).toLocaleString()}`
                    : "N/A"}
                </td>
                <td>
                  {item?.keyPrice && item?.evenPrice
                    ? `${(((item.keyPrice - item.evenPrice) / item.keyPrice) * 100).toFixed(2)}%`
                    : "N/A"}
                </td>
                <td>
                  {(() => {
                    const { isValid, days } = getPriceValidity(item?.scrapedAt, outdatedDays);
                    return (
                      <div className="d-flex flex-column align-items-center">
                        <span className={`${isValid === "Yes" ? "text-success" : "text-danger"} font-weight-bold`}>{isValid}</span>
                        <span className="text-muted small">{days}</span>
                      </div>
                    );
                  })()}
                </td>
                <td>
                  {(() => {
                    const status = item?.linkStatus;
                    let displayStatus = status || "-";
                    let color = "#495057";

                    if (status === "valid") {
                      color = "#28a745";
                      displayStatus = "Valid";
                    } else if (status === "invalid") {
                      color = "#dc3545";
                      displayStatus = "Invalid";
                    } else if (status === "notFound") {
                      color = "#ffc107";
                      displayStatus = "Not Found";
                    }

                    return (
                      <span className="font-weight-bold" style={{ color }}>
                        {displayStatus}
                      </span>
                    );
                  })()}
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-dark rounded-pill px-3 py-1 bg-white"
                    onClick={() => handleDetailClick(item)}
                    style={{ border: '1px solid #ced4da', color: '#495057' }}
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={16} className="text-center">No Record Found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  const renderPriceVariables = () => <PriceVariables />;

  const renderPriorityVariables = () => <PriorityVariables />;

  const renderFrequencyVariables = () => <FrequencyVariables />;

  return (
    <div className="bg-white rounded shadow-sm py-4">
      <PricingTabs activeTab={activeTab} onTabChange={setActiveTab} />

      {activeTab === "dashboard" && (
        <div className="px-4 mt-4">
          <div className="d-flex justify-content-start align-center gap-3 flex-wrap mb-4">
            <div className="rounded-pill border px-3 py-1 d-flex align-items-center bg-light" style={{ width: '300px', height: '60px' }}>
              <input
                type="text"
                placeholder="Search item name, sku"
                className="border-0 bg-transparent w-100 outline-none"
                style={{ outline: 'none', fontSize: '14px' }}
                value={SearchFillter?.title}
                onChange={(e) => {
                  setSearchFillter({ ...SearchFillter, title: e.target.value });
                  resetToFirstPage();
                }}

              />
            </div>

            <SelectSearchFilter
              title="Brand"
              placeholder="Select Brand"
              width="200px"
              className="rounded-pill"
              value={SearchFillter?.brandId ? Brand.find(i => i.id === SearchFillter.brandId)?.value : ""}
              options={Brand}
              onChange={(val) => {
                const selected = Brand.find(i => i.value === val);
                setSearchFillter({ ...SearchFillter, brandId: selected ? selected.id : "" });
                resetToFirstPage();
              }}

            />

            <SelectSearchFilter
              title="Category"
              width="200px"
              placeholder="Select Category"
              className="rounded-pill"
              value={SearchFillter?.categoryName}
              options={Categories}
              onChange={(val) => {
                setSearchFillter({ ...SearchFillter, categoryName: val });
                resetToFirstPage();
              }}

            />

            <button
              className="btn btn-dark rounded-pill px-4 py-2 ml-auto"
              style={{ height: '40px', fontSize: '13px', fontWeight: '500' }}
              onClick={() => setUpdateLatestDrawer({ open: true, edit: "update", title: "Update Latest" })}
            >
              Update Latest Price History
            </button>

            <button
              className="btn btn-outline-dark rounded-pill px-4 py-2"
              style={{ height: '40px', fontSize: '13px', fontWeight: '500' }}
              onClick={() => setExportDrawer({ open: true, title: "Export Price History" })}
              disabled={isExporting}
            >
              Export to Excel
            </button>

            <button
              className="btn btn-outline-dark rounded-pill px-4 py-2"
              style={{ height: '40px', fontSize: '13px', fontWeight: '500' }}
              onClick={() => setGlobalPricingSettingsDrawer({ open: true, title: "Global Pricing Settings" })}
            >
              Global Pricing Settings
            </button>

            <button
              className="btn btn-outline-danger rounded-pill px-4 py-2"
              style={{ height: '40px', fontSize: '13px', fontWeight: '500' }}
              onClick={() => setIgnoreCompetitorDrawer({ open: true, title: "Manage Ignored Competitors" })}
            >
              Ignore Competitor
            </button>
          </div>

          {isHistoryLoading ? (
            <TableLoader rowsNum={10} cellNum={16} />
          ) : (
            <>
              <DashboardPagesLayout
                pageTitle="Dynamic Pricing"
                subTitle="items"
                count={pagePagination?.count}
                rightHeaderContent={
                  <Pagination
                    count={pagePagination.totalPages}
                    page={pagePagination.currentPage}
                    onChange={handleChange}
                    color="primary"
                    size="small"
                  />
                }
              >
                {renderDashboardTable()}
                <div className="d-flex justify-content-between align-center p-3 border-top mt-3">
                  <span className="text-muted font-weight-bold">
                    {crawlers?.length} of {pagePagination?.count} Items
                  </span>
                  <Pagination
                    count={pagePagination.totalPages}
                    page={pagePagination.currentPage}
                    onChange={handleChange}
                    color="primary"
                  />
                </div>
              </DashboardPagesLayout>
            </>
          )}
        </div>
      )}

      {activeTab === "variables" && renderPriceVariables()}
      {activeTab === "priority" && renderPriorityVariables()}
      {activeTab === "frequency" && renderFrequencyVariables()}

      {/* Side bar Drawers */}
      <PriceCardDrawer Edit={Edit} setEdit={setEdit} shippingId="22" width="700px">
        <PriceCard productInfo={productInfo} />
      </PriceCardDrawer>

      <PriceCardDrawer
        Edit={dynamicPricing}
        setEdit={setDynamicPricing}
        shippingId="23"
        width="auto"
      >
        <PricingSidebar
          selectedProductInfo={productInfo}
          selectedItemBrandId={selectedItemBrandId}
        />
      </PriceCardDrawer>

      <PriceCardDrawer
        Edit={updateLatestDrawer}
        setEdit={setUpdateLatestDrawer}
        shippingId="24"
        width="600px"
      >
        <BatchUpdateDrawerContent onClose={() => setUpdateLatestDrawer({ open: false, edit: "", title: "" })} />
      </PriceCardDrawer>

      <PriceCardDrawer
        Edit={exportDrawer}
        setEdit={setExportDrawer}
        shippingId="25"
        width="600px"
      >
        <ExportBrandDrawerContent 
          brands={Brand} 
          onExport={(ids) => {
            handleExportAll(ids);
            setExportDrawer({ open: false, title: "" });
          }} 
          isExporting={isExporting} 
          onClose={() => setExportDrawer({ open: false, title: "" })}
        />
      </PriceCardDrawer>

      <PriceCardDrawer
        Edit={ignoreCompetitorDrawer}
        setEdit={setIgnoreCompetitorDrawer}
        shippingId="26"
        width="600px"
      >
        <ManageIgnoredCompetitors />
      </PriceCardDrawer>

      <PriceCardDrawer
        Edit={globalPricingSettingsDrawer}
        setEdit={setGlobalPricingSettingsDrawer}
        shippingId="27"
        width="600px"
      >
        <GlobalPricingSettings onClose={() => setGlobalPricingSettingsDrawer({ open: false, title: "" })} />
      </PriceCardDrawer>
    </div>
  );
};

export default DynamicPricing;
